import axios from 'axios';

const gazetteerService = axios.create({
    baseURL: 'https://gazetteers.run.shipnext.com',
    auth: {
        username: 'admin',
        password: '7ErdM[~SbGt$+.2!',
    },
});

export function saveToStaging() {
    return gazetteerService.post('/snapshot');
}

export function saveToProduction() {
    return gazetteerService.post('/deploy');
}

export function postGazetters(text, options = {}) {
    return axios({
        method: 'POST',
        url: 'https://gazetteers.run.shipnext.com/annotate',
        data: { text, ...options },
    })
        .then(response => response)
        .catch(response => response);
}

export function saveGazetters(gazetters) {
    return axios({
        method: 'POST',
        url: '/api/v1/gazetters',
        data: gazetters,
        withCredentials: true,
    })
        .then(response => response)
        .catch(response => response);
}

export function loadGazetteerIndex() {
    return gazetteerService.get('/def');
}

export function saveGazetteerIndex(version, content) {
    return gazetteerService.put('/def', content, {
        params: {
            version,
        },
    });
}

export function loadGazetteer(filename, type) {
    return gazetteerService.get(`/lst/${filename}`);
}

export function saveGazetteer(filename, version, content) {
    return gazetteerService.put(`/lst/${filename}`, content, {
        headers: {
            'Content-Type': 'text/plain',
        },
        params: {
            version,
        },
    });
}


export function removeGazetteerDuplicates(filename) {
    return gazetteerService.post(`/lst/removeDuplicates/${filename}`, undefined);
}

export function syncFeaturesFromDb() {
    return gazetteerService.post('/syncFeatures', undefined);
}

export function saveGazettersNew(gazetters) {
    return gazetteerService.patch('/lst', gazetters, {
        withCredentials: true,
    });
}

/**
 * 
 * @param {string} gazetterName 
 * @param {GazetteerOperation[]} values 
 * @returns 
 */
export function saveGazetterPartially(gazetterName, values, version) {
    return gazetteerService.patch(`/lst/${gazetterName}`, values, {
        withCredentials: true,
        params: {
            version,
        },
    });
}

/**
 * Array of gazetteer operation objects that define changes to be made to gazetteers.
 * Each operation object has a status field that determines the type of operation.
 * 
 * @typedef {Object} GazetteerOperation
 * @property {"new"|"replace"|"remove"|"renameFeature"} status - The type of operation to perform
 * @property {string} value - The new value or target value for the operation
 * @property {string} [oldValue] - The old value being replaced (required for "replace" and "renameFeature" operations)
 * @property {Object|null} [lastFeatures] - The last known features object (used for "new" and "replace" operations)

 */

/**
 * Fetch predicted score for a specific line
 * @param {string} text - The line text to get score for
 * @param {string} mailId - The letter ID for context
 * @returns {Promise<{ data: any[], errors: any[] }>}
 */
export function fetchLineScore(text, mailId) {
    return axios({
        method: 'POST',
        url: '/api/v1/predictor/line-score',
        data: { text, _id: mailId },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch((error) => {
            throw error;
        });
}

/**
 * send training batch to the server
 * @param {string} mailId - The letter ID for context
 * @param {{ usefulToNotUseful: string[], notUsefulToUseful: string[] }} data - array of batch items
 */
export function sendTrainingBatch(mailId, data) {
    return axios({
        method: 'POST',
        url: '/api/v1/predictor/training-batch',
        data: { 
            _id: mailId,
            data,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch((error) => {
            throw error;
        });
}



// WEBPACK FOOTER //
// ./app/services/gazetters.js